export default "__VITE_ASSET__1acacde7__"